import client from 'api-client';

const portalId = process.env.VUE_APP_PORTAL_ID || process.env.VUE_APP_PORTAL;
const storageSupported = typeof(Storage) !== 'undefined';
const PORTAL_DOWNLOAD_INFO = "PORTAL_DOWNLOAD_INFO_" + portalId;

function storeDownloadInfo(state) {
  if (storageSupported) {
    let newDownloadsInfo = JSON.stringify({
      jobsInProgress: state.jobsInProgress,
      successToNotify: state.successToNotify,
      errorToNotify: state.errorToNotify
    });
    if (localStorage[PORTAL_DOWNLOAD_INFO] !== newDownloadsInfo) {
      localStorage[PORTAL_DOWNLOAD_INFO] = newDownloadsInfo;
    }
  }
}

function getStoredDownloadInfo() {
  if (storageSupported) {
    return JSON.parse(localStorage[PORTAL_DOWNLOAD_INFO]);
  }
  return null;
}

function findNewItems(oldArray, newArray) {
  let newItems = [];
  for (let i = 0; i < newArray.length; i++) {
    if (!oldArray.includes(newArray[i])) {
      newItems.push(newArray[i]);
    }
  }
  return newItems;
}

export default {
  state: {
    notifications: [],
    currentPage: 1,
    totalItems: 0,
    totalFiles: 0,
    freeSpace: null,
    initialLoading: true,
    loading: true,
    jobsInProgress: 0,
    jobRunning: false,
    successToNotify: [],
    errorToNotify: [],
    messagesShown: []
  },
  actions: {
    loadFilesPanel({ dispatch, state }, page) {
      state.loading = true;
      state.currentPage = page;
      client.getFilesPanel(page)
        .then(panel => dispatch('updateFilesPanel', panel))
        .catch(() => {})
        .then(() => {
          state.loading = false;
          state.initialLoading = false;
        });
    },
    updateFilesPanel({ dispatch, state }, panel) {
      state.notifications = panel.notifications;
      state.currentPage = panel.currentPage;
      state.totalItems = panel.totalItems;
      state.totalFiles = panel.totalFiles;
      state.freeSpace = panel.freeSpace;
      state.loading = false;
      storeDownloadInfo(panel);
      dispatch('updateJobStatus', panel);
    },
    deleteNotification({ dispatch, state }, notificationId) {
      state.loading = true;
      client.deleteNotification(notificationId, state.currentPage)
        .then(panel => dispatch('updateFilesPanel', panel));
    },
    newJob({ dispatch, state, rootState }, jobOptions) {
      state.jobRunning = true;
      client.startJob(jobOptions)
        .then(result => {
          document.dispatchEvent(new CustomEvent('showMessage', {
            detail: {
              message: "File creation started",
              options: {
                title: "Done",
                variant: 'success'
              }
            }
          }));
          dispatch('updateJobStatus', result);
        })
        .catch(() => {})
        .then(() => {
          state.loading = false;
        });
    },
    updateJobStatus({ dispatch, state }, result) {
      let newFiles = findNewItems(state.successToNotify, result.successToNotify);
      let newErrors = findNewItems(state.errorToNotify, result.errorToNotify);

      if (newFiles.length > 0) {

        let showInfoMessage = false;
        for (let i = 0; i < newFiles.length; i++) {
          if (!state.messagesShown.includes(newFiles[i])) {
            showInfoMessage = true;
          }
        }

        if (showInfoMessage) {
          document.dispatchEvent(new CustomEvent('showMessage', {
            detail: {
              message: "New files ready to be downloaded!",
              options: {
                title: "Done",
                variant: 'success'
              }
            }
          }));
        }

        for (let i = 0; i < newFiles.length; i++) {
          state.successToNotify.push(newFiles[i]);
          state.messagesShown.push(newFiles[i]);
        }
      }

      if (newErrors.length > 0) {

        let showErrorMessage = false;
        for (let i = 0; i < newErrors.length; i++) {
          if (!state.messagesShown.includes(newErrors[i])) {
            showErrorMessage = true;
          }
        }

        for (let i = 0; i < newErrors.length; i++) {
          state.errorToNotify.push(newErrors[i]);
        }

        if (showErrorMessage) {
          document.dispatchEvent(new CustomEvent('showMessage', {
            detail: {
              message: "An error happened!",
              options: {
                title: "Error",
                variant: 'danger'
              }
            }
          }));
        }
      }

      if (newFiles.length > 0 || newErrors.length > 0) {
        storeDownloadInfo(state);
        dispatch('loadFilesPanel', state.currentPage);
      }

      if (result.jobsInProgress === 0) {
        state.jobRunning = false;
      } else {
        setTimeout(() => dispatch('checkJobsStatus'), 2000);
      }
    },
    checkJobsStatus({ dispatch }) {
      client.checkJobsStatus()
        .then(result => {
          dispatch('updateJobStatus', result);
        });
    },
    storageEvent({ dispatch }) {
      dispatch('updateJobStatus', getStoredDownloadInfo());
    },
    clearNotifications({ dispatch, state }) {
      if (state.successToNotify.length > 0 || state.errorToNotify.length > 0) {
        let notifications = state.successToNotify.concat(state.errorToNotify);
        client.clearNotifications(notifications)
          .then(result => {
            state.successToNotify = [];
            state.errorToNotify = [];
            dispatch("updateJobStatus", result);
          });
      }
    }
  }
}
